/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GuaranteeDtoDeductible } from './GuaranteeDtoDeductible';
import {
    GuaranteeDtoDeductibleFromJSON,
    GuaranteeDtoDeductibleFromJSONTyped,
    GuaranteeDtoDeductibleToJSON,
    GuaranteeDtoDeductibleToJSONTyped,
} from './GuaranteeDtoDeductible';

/**
 * 
 * @export
 * @interface GuaranteeDto
 */
export interface GuaranteeDto {
    /**
     * Unique identifier of the guarantee product
     * @type {string}
     * @memberof GuaranteeDto
     */
    id: string;
    /**
     * Unique identifier of the guarantee product
     * @type {string}
     * @memberof GuaranteeDto
     */
    guaranteeTunnelId: string;
    /**
     * Name of the guarantee
     * @type {string}
     * @memberof GuaranteeDto
     */
    name: string;
    /**
     * Short name of the guarantee
     * @type {string}
     * @memberof GuaranteeDto
     */
    shortName?: string;
    /**
     * Short description of the guarantee
     * @type {string}
     * @memberof GuaranteeDto
     */
    shortDescription?: string;
    /**
     * Long description of the guarantee
     * @type {string}
     * @memberof GuaranteeDto
     */
    longDescription?: string;
    /**
     * Indicates if the guarantee is required
     * @type {boolean}
     * @memberof GuaranteeDto
     */
    isRequired: boolean;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeDto
     */
    warningMessage?: string;
    /**
     * 
     * @type {GuaranteeDtoDeductible}
     * @memberof GuaranteeDto
     */
    deductible?: GuaranteeDtoDeductible;
    /**
     * 
     * @type {GuaranteeDtoDeductible}
     * @memberof GuaranteeDto
     */
    ceiling?: GuaranteeDtoDeductible;
    /**
     * List of child guarantees
     * @type {Array<GuaranteeDto>}
     * @memberof GuaranteeDto
     */
    childrens?: Array<GuaranteeDto>;
}

/**
 * Check if a given object implements the GuaranteeDto interface.
 */
export function instanceOfGuaranteeDto(value: object): value is GuaranteeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('guaranteeTunnelId' in value) || value['guaranteeTunnelId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isRequired' in value) || value['isRequired'] === undefined) return false;
    return true;
}

export function GuaranteeDtoFromJSON(json: any): GuaranteeDto {
    return GuaranteeDtoFromJSONTyped(json, false);
}

export function GuaranteeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuaranteeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'guaranteeTunnelId': json['guaranteeTunnelId'],
        'name': json['name'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'shortDescription': json['shortDescription'] == null ? undefined : json['shortDescription'],
        'longDescription': json['longDescription'] == null ? undefined : json['longDescription'],
        'isRequired': json['isRequired'],
        'warningMessage': json['warningMessage'] == null ? undefined : json['warningMessage'],
        'deductible': json['deductible'] == null ? undefined : GuaranteeDtoDeductibleFromJSON(json['deductible']),
        'ceiling': json['ceiling'] == null ? undefined : GuaranteeDtoDeductibleFromJSON(json['ceiling']),
        'childrens': json['childrens'] == null ? undefined : ((json['childrens'] as Array<any>).map(GuaranteeDtoFromJSON)),
    };
}

export function GuaranteeDtoToJSON(json: any): GuaranteeDto {
    return GuaranteeDtoToJSONTyped(json, false);
}

export function GuaranteeDtoToJSONTyped(value?: GuaranteeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'guaranteeTunnelId': value['guaranteeTunnelId'],
        'name': value['name'],
        'shortName': value['shortName'],
        'shortDescription': value['shortDescription'],
        'longDescription': value['longDescription'],
        'isRequired': value['isRequired'],
        'warningMessage': value['warningMessage'],
        'deductible': GuaranteeDtoDeductibleToJSON(value['deductible']),
        'ceiling': GuaranteeDtoDeductibleToJSON(value['ceiling']),
        'childrens': value['childrens'] == null ? undefined : ((value['childrens'] as Array<any>).map(GuaranteeDtoToJSON)),
    };
}

